import Vue from "vue";
import VueRouter from "vue-router";
import StartPage from "../components/login/StartPage";
import SelectCountryPage from "../components/login/SelectCountryPage";
import LoginPage from "../components/login/LoginPage.vue";
import UserProgressPage from "../components/progressApp/UserProgressPage.vue";
import ForgetPasswordPage from "../components/login/ForgetPasswordPage.vue";
import RegisterPage from "../components/login/RegisterPage.vue";
import ConfirmEmailPage from "../components/login/ConfirmEmailPage.vue";
import HomePage from "../components/home/HomePage.vue";
import ResetPasswordPage from "../components/login/ResetPasswordPage.vue";
import ChangePasswordPage from "../components/home/ChangePasswordPage.vue";
import NotFound404 from "../components/NotFound404.vue";
import UserSettingsPage from "../components/home/UserSettingsPage.vue";
import SchedulingHomePage from "../components/schedulerApp/SchedulingHomePageComponent.vue";
import MaintenancePage from "../components/maintenancePage.vue";

import i18n from "../internationalization/i18n.js";

// const { getAppTranslation } = require('../actions/onloadActions.js');

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "StartPage",
    component: StartPage,
    meta: { guest: true },
  },
  {
    path: "/start",
    name: "Start Page",
    component: StartPage,
    meta: { guest: true },
  },
  {
    path: "/selectCountry",
    name: "SelectCountryPage",
    component: SelectCountryPage,
    meta: { guest: true },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { guest: true },
  },
  // {
  //   path: "/login/:email/:mobileId",
  //   name: "LoginWithParams",
  //   component: LoginPage,
  //   meta: {guest: true},
  // },
  {
    path: "/my-progress",
    name: "My Progress",
    component: UserProgressPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    component: ForgetPasswordPage,
    meta: { guest: true },
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterPage,
    meta: { guest: true },
  },
  {
    path: "/register/:email/:token/:type",
    name: "Register Invitation",
    component: RegisterPage,
    meta: { guest: true },
  },
  {
    path: "/confirm",
    name: "Confirm Info",
    component: ConfirmEmailPage,
    meta: { guest: true },
  },
  {
    path: "/confirm/:email/:token",
    name: "Confirmimg Email",
    component: ConfirmEmailPage,
    meta: { guest: true },
  },
  {
    path: "/home",
    name: "Home",
    component: HomePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/home/:email/:mobileId",
    name: "LoginWithParams",
    component: HomePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/reset-password/:email/:token",
    name: "Reset Password",
    component: ResetPasswordPage,
    meta: { guest: true },
  },
  {
    path: "/change-password",
    name: "Change Password",
    component: ChangePasswordPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/settings",
    name: "User Settings",
    component: UserSettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/scheduling",
    name: "Scheduler App",
    component: SchedulingHomePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/maintenance",
    name: "MaintenancePage",
    component: MaintenancePage,
    meta: { guest: true },
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFound404,
  },
  {
    path: "*",
    redirect: "/home", // Catch-all another routes
  },
];

const router = new VueRouter({
  mode: "history", // Use history mode instead of hash mode
  routes,
  // store,
});

// Maintenance mode flag
const isMaintenanceMode = false;

router.beforeEach(async (to, from, next) => {

  // // Fetch the languages
  // const translationResponse = await getAppTranslation();
  // console.log("translationResponse...");
  // console.log(translationResponse);
  // if (translationResponse.status) {
  //     Vue.prototype.$store.allLanguages = translationResponse.data;
  // }
  // else {
  //     Vue.prototype.$store.allLanguages = i18n.messages;
  // }

  // Get the user agent string from the HTTP headers
  const userAgent = navigator.userAgent;

  // Check if the user agent string contains specific keywords
  if (userAgent.includes("webView")) {
      // This suggests the website is being opened in a WebView (likely a mobile app)
      Vue.prototype.$store.requestSource = userAgent;
  } else {
      // This suggests the website is being opened in a regular web browser
      Vue.prototype.$store.requestSource = "browser";
  }

  // Select the source of language messages when navigate between the routes.
  let messages;
  if (Vue.prototype.$store.allLanguages) {
    messages = Vue.prototype.$store.allLanguages;
  }
  else {
    messages = i18n.messages;
  }
  i18n.locale = Vue.prototype.$store.selectedAppLanguage;
  i18n.setLocaleMessage(i18n.locale, messages[i18n.locale]);

  if (Vue.prototype.$store.selectedAppLanguage !== "en") {
    Vue.prototype.$store.changeAppLanguage(Vue.prototype.$store.selectedAppLanguage);
  }

  // Redirect all requests to the MaintenancePage if maintenance mode is active
  if (isMaintenanceMode) {
    Vue.prototype.$store.showFooterBackBtn = false;
    if (to.path !== "/maintenance") {
      return next({ path: "/maintenance" });
    }
    else {
      return next();
    }
  }
  else {
    // const testValue = to.matched.some((record) => record.meta.requiresAuth);
    // console.log("testValue: " + testValue);
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      // console.log(to.path);
      // console.log(to.params);
      if (localStorage.getItem("user")) {
        // console.log("test 1");
        switch (to.path) {
          case "/":
            next({ path: "/home" });
            break;
          case "/home":
            {
              Vue.prototype.$store.showFooterBackBtn = true;
              next();
            }
            break;
          default:
            // console.log("to.path: " + to.path);
            // console.log("Vue.prototype.$store.requestSource: " + Vue.prototype.$store.requestSource);
            if (
              to.path.startsWith("/home/") &&
              Vue.prototype.$store.requestSource.includes("webView") &&
              to.params.email &&
              Vue.prototype.$store.EmailValidation(to.params.email) &&
              to.params.mobileId
            ) {
              // console.log("to.params.email from the router: " + to.params.email);
              next();
              break;
            } else {
              // console.log("to.path from the router: " + to.path);
              next();
              break;
            }
        }
      } else {
        // console.log("test 2");
        // console.log(to.path);
        // console.log("Vue.prototype.$store.requestSource: " + Vue.prototype.$store.requestSource);
        if (
          to.path.startsWith("/my-progress") &&
          ((to.query.email && to.query.token) || (to.query.id && to.query.api_key))
        ) {
          next();
        }
        else if (
          to.path.startsWith("/home/") &&
          Vue.prototype.$store.requestSource.includes("webView") &&
          to.params.email &&
          Vue.prototype.$store.EmailValidation(to.params.email) &&
          to.params.mobileId
        ) {
          // console.log("to.params.email: " + to.params.email);
          next();
        } else {
          next({
            path: "/start",
            // query: { redirect: to.fullPath },
          });
        }
      }
    } else if (to.matched.some((record) => record.meta.guest)) {
      if (localStorage.getItem("user")) {
        // console.log("test 3");
        next({ path: "/home" });
      } else {
        // console.log("test 4");
        // console.log(to.path);
        switch (to.path) {
          case "/scheduling":
          case "/":
          case "/start":
          case "/forget-password":
          case "/change-password":
          case "/startPage":
          case "/settings":
          case "/confirm":
          case "/404":
            {
              Vue.prototype.$store.showFooterBackBtn = true;
              next();
            }
            break;
          case "/login":
          case "/register":
            {
              Vue.prototype.$store.showFooterBackBtn = false;
              next();
            }
            break;
          case "/selectCountry":
            {
              Vue.prototype.$store.showFooterBackBtn = true;
              Vue.prototype.$store.selectCountryPage = true;
              next();
            }
            break;
          default:
            if (
              to.path.startsWith("/confirm/") &&
              to.params.email &&
              Vue.prototype.$store.EmailValidation(to.params.email) &&
              to.params.token
            ) {
              
              if (to.query.lang) {
                Vue.prototype.$store.changeAppLanguage(to.query.lang);
              }

              Vue.prototype.$store.showFooterBackBtn = false;
              Vue.prototype.$store.confirmingAccount = true;
              next();
              break;
            } else if (
              to.path.startsWith("/reset-password/") &&
              to.params.email &&
              Vue.prototype.$store.EmailValidation(to.params.email) &&
              to.params.token
            ) {
              if (to.query.lang) {
                Vue.prototype.$store.changeAppLanguage(to.query.lang);
              }
              next();
              break;
            } else if (
              to.path.startsWith("/register/") &&
              to.params.email &&
              Vue.prototype.$store.EmailValidation(to.params.email) &&
              to.params.token &&
              to.params.type &&
              to.params.type == "invite"
            ) {
              Vue.prototype.$store.showFooterBackBtn = false;
              Vue.prototype.$store.registerViaInvitationLink = true;
              Vue.prototype.$store.user.email = to.params.email;
              next();
              break;
            } else if (
              to.path.startsWith("/my-progress/") &&
              Object.keys(to.query).length > 0
            ) {
              // console.log(to.query);
              next();
              break;
            } else if (
              to.path.startsWith("/confirm") &&
              !Vue.prototype.$store.unconfirmedAccount &&
              !Vue.prototype.$store.registrationCompleted
            ) {
              next("/404");
              break;
            } else {
              // console.log(to.params);
              // console.log(to.path);
              next("/home");
              break;
            }
        }
      }
    } else {
      next({ path: "/home" });
    }
  }
});

export default router;
